/*
  Works in conjunction with pages that use donation widget.
  Gives the ability to set the donation widget params in
  the page url.

  Page url params will supersede those set on a donation
  widget button href.
*/

const urlPageParams = window.location.search.substring(1);
const $donateButtons = $('.widget-overlay-trigger');

function updateWidgetParams () {
  if (urlPageParams.length !== 0) {
    $donateButtons.each(function () {
      if ($(this).attr('value') === 'give_monthly') {
        this.search = ''.concat(setDonationParams('once'));
      } else if ($(this).attr('value') === 'give_once') {
        this.search = ''.concat(setDonationParams('monthly'));
      } else {
        this.search = ''.concat(urlPageParams);
      }
    });
  }
}

function setDonationParams (invalidType) {
  const params = urlPageParams.split('&');
  const index = params.indexOf(`donation_type=${invalidType}`);

  if (index > -1) {
    params.splice(index, 1);
  }

  if (invalidType === 'once' && !params.includes('donation_type=monthly')) {
    params.push('donation_type=monthly');
    return params.join('&');
  }
  return params.join('&');
}

updateWidgetParams();
